import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message, Checkbox, Spin } from "antd";
import Bridge from "../../utils/Bridge";
import {RESEARCH_TYPE} from '../../utils/consts';

export default class UpdateAlsfrsAndRoads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      is_alsfrs_present:false,
      is_rasch_present:false
    };
  }
  componentDidMount() {
    this.check_forms_submitted_or_not();
  }
  check_forms_submitted_or_not=()=>{
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type=form';
    Bridge.participants.speech.alsfrs
    .list(params)
    .then((response) => {
      if (response.status == "1") {
        
        this.setState({
          is_alsfrs_present:response.data.is_alsfrs_present,
          is_rasch_present: response.data.is_rasch_present,
          loading:false
        })

      }else{
        this.setState({loading:false})
      }
    }).catch((error)=>{
      this.setState({loading:false})
    })
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Dashboard
                  </a>
                  <Spin spinning={this.state.loading}>
                    <div className="demographics-wrapper p-0">

                      {this.state.is_alsfrs_present!=true && (
                        <div className="single-account">
                          <a
                            href="/update-alsfrs"
                            style={{ textDecoration: "none" }}
                          >
                            <div className="block">
                              <div className="d-flex align-items-center">
                                <h4 className="mb-0 pb-0">ALSFRS-R</h4>
                              </div>
                              <a
                                href="/update-alsfrs"
                                className="update-button"
                              >
                                NEXT{" "}
                                <box-icon
                                  name="chevron-right"
                                  color="#fff"
                                  style={{ position: "relative", top: 0 }}
                                ></box-icon>
                              </a>
                            </div>
                          </a>
                        </div>
                      )}
                      {this.state.is_rasch_present!=true && (
                        <div className="single-account">
                          <a
                            href="/update-roads"
                            style={{ textDecoration: "none" }}
                          >
                            <div className="block">
                              <div className="d-flex align-items-center">
                                <h4 className="mb-0 pb-0">Rasch Overall ALS Disability Scale (ROADS)</h4>
                              </div>
                              <a
                                href="/update-roads"
                                className="update-button"
                              >
                                NEXT{" "}
                                <box-icon
                                  name="chevron-right"
                                  color="#fff"
                                  style={{ position: "relative", top: 0 }}
                                ></box-icon>
                              </a>
                            </div>
                          </a>
                        </div>
                      )}
                      <div className="single-account">
                        <a
                          href="/thank-you"
                          style={{ textDecoration: "none" }}
                        >
                          <div className="block">
                            <div className="d-flex align-items-center">
                              <h4 className="mb-0 pb-0">Thank You</h4>
                            </div>
                            <a
                              href="/thank-you"
                              className="update-button"
                            >
                              NEXT{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 0 }}
                              ></box-icon>
                            </a>
                          </div>
                        </a>
                      </div>

                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
